import { roundMoney2 } from './money';

/** Округляет cost и суммы в expenses перед POST/PUT /tasks */
export function normalizeCostForSubmit(submitData) {
  if (!submitData || typeof submitData !== 'object') return;
  if (Object.prototype.hasOwnProperty.call(submitData, 'cost')) {
    submitData.cost = roundMoney2(submitData.cost);
  }
  if (Array.isArray(submitData.expenses)) {
    submitData.expenses = submitData.expenses.map((e) => {
      if (!e || typeof e !== 'object') return e;
      const next = { ...e };
      if (Object.prototype.hasOwnProperty.call(next, 'amount')) {
        next.amount = roundMoney2(next.amount);
      }
      return next;
    });
  }
}
